import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonLink } from './Link.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonLink({ prefix }));
}
